import type { WireProviderOutboxEvent } from '../../api/endpoints.js';
import type { useApiQuery } from '../../api/hooks.js';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  EmptyState,
  ErrorState,
  Icon,
  LoadingState,
  TBody,
  TD,
  TH,
  THead,
  TRow,
  Table,
} from '../../ui/index.js';
import { fmtDate, toneForEvent } from './shared.js';

export function EventsPanel({
  query,
  onRefresh,
}: {
  readonly query: ReturnType<typeof useApiQuery<{ events: readonly WireProviderOutboxEvent[] }>>;
  readonly onRefresh: () => void;
}): JSX.Element {
  return (
    <Card flush>
      <CardHeader
        title="Provider Olayları"
        actions={
          <Button variant="ghost" size="sm" onClick={onRefresh} icon={<Icon.Refresh size={12} />}>
            Yenile
          </Button>
        }
      />
      <CardBody>
        <p className="t-tertiary t-small" style={{ margin: '0 0 12px' }}>
          Outbox tablosundan son provider_account / provider_alias / provider_renewal_job eventleri. Hiçbir
          secret/payload alanı UI'da gösterilmez; yalnızca event meta-verisi.
        </p>

        {query.kind === 'loading' ? <LoadingState /> : null}
        {query.kind === 'error' ? <ErrorState reason={query.reason} onRetry={onRefresh} /> : null}
        {query.kind === 'ok' ? (
          (query.data?.events ?? []).length === 0 ? (
            <EmptyState label="Outbox'ta provider event'i yok." />
          ) : (
            <Table dense>
              <THead>
                <TRow>
                  <TH>Event</TH>
                  <TH>Aggregate</TH>
                  <TH>Durum</TH>
                  <TH>Deneme</TH>
                  <TH>Oluşturulma</TH>
                  <TH>Yayınlandı</TH>
                  <TH>Hata</TH>
                </TRow>
              </THead>
              <TBody>
                {(query.data?.events ?? []).map((e) => (
                  <TRow key={e.id}>
                    <TD className="t-mono t-xs">{e.eventType}</TD>
                    <TD className="t-mono t-xs">
                      {e.aggregateType}/{e.aggregateId.slice(0, 8)}…
                    </TD>
                    <TD>
                      <Badge tone={toneForEvent(e.status)} dot>{e.status}</Badge>
                    </TD>
                    <TD className="t-mono t-num">{e.attempts}</TD>
                    <TD className="t-mono t-xs t-tertiary">{fmtDate(e.createdAt)}</TD>
                    <TD className="t-mono t-xs t-tertiary">{fmtDate(e.publishedAt)}</TD>
                    <TD
                      className="t-mono t-xs"
                      style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {e.lastError ?? '—'}
                    </TD>
                  </TRow>
                ))}
              </TBody>
            </Table>
          )
        ) : null}
      </CardBody>
    </Card>
  );
}
